import { render, staticRenderFns } from "./ComponentQuerConhecerMelhorOsDetalhes.vue?vue&type=template&id=7bc07e32&scoped=true&"
import script from "./ComponentQuerConhecerMelhorOsDetalhes.vue?vue&type=script&lang=js&"
export * from "./ComponentQuerConhecerMelhorOsDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ComponentQuerConhecerMelhorOsDetalhes.vue?vue&type=style&index=0&id=7bc07e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc07e32",
  null
  
)

export default component.exports